module.exports = __webpack_public_path__ + "static/google-b45ee991dcd76b55627148996b807a4d.png";